import React from 'react';

import { useAccountContext } from '../Data/accountContext';
import FormBase from '../FormBase';
import SelectSystemCode from '../../../../components/Dropdown/SelectSystemCode';
import TextField from '../../../../components/Textfields/TextField';
import { SelectSourceOfFunds } from '../../../../components/MultipleSelect/SelectSourceOfFunds';
import { hasError, validateObjective } from '../Data/validation';
import { saveRegistrationObjective } from '../../../../services/RegistrationService';

export default function FormObjective() {
  const { account, setAccount, investmentObjectives } = useAccountContext();
  const [validation, setValidation] = React.useState({});

  const handleSave = async () => {
    const errs = validateObjective(account.objective, investmentObjectives);
    setValidation(errs);
    if (hasError(errs)) {
      console.log('objective errs', errs);
      return { acct: account, err: true };
    }

    await saveRegistrationObjective(account.objective);

    return { acct: account, err: false };
  };

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    let copy = { ...account };
    copy.objective[input.name] = input.value;

    setAccount(copy);
  };

  const handleMultipleFundsChange = (selected) => {
    const copy = { ...account };
    copy.objective.sourceOfFunds = selected.map((e) => e.value).join(',');

    setAccount(copy);
  };

  const data = account?.objective || {
    sourceOfFunds: '',
  };

  return (
    <FormBase
      name="objective"
      header="Investment Objective"
      subHeader=""
      faq="Objective"
      save={handleSave}
    >
      <form className="risk-objective-form-w" autoComplete="off">
        <SelectSystemCode
          required={true}
          error={!!validation.investmentObjectiveCode}
          msg={validation.investmentObjectiveCode}
          name="investmentObjectiveCode"
          label="Investment Objective"
          placeholder="Investment Objective"
          type="Investment Objective"
          subType=""
          value={data.investmentObjectiveCode || ''}
          onChange={handleChange}
        />
        <div className="grd-row">
          <div className="grd-cell">
            <SelectSystemCode
              required={true}
              error={!!validation.annualIncome}
              msg={validation.annualIncome}
              tooltip="Employment, alimony, social security, investment income, etc."
              name="annualIncome"
              label="Annual Income"
              placeholder="Annual Income"
              type="Investment Objectives"
              subType="Annual Income"
              orderBy="note"
              value={data.annualIncome || ''}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell">
            <SelectSystemCode
              required={true}
              error={!!validation.liquidNetWorth}
              msg={validation.liquidNetWorth}
              tooltip="Total amount of all assets that can be readily converted to cash."
              name="liquidNetWorth"
              label="Liquid Net Worth"
              placeholder="Liquid Net Worth"
              type="Investment Objectives"
              subType="Liquid Net Worth"
              orderBy="note"
              value={data.liquidNetWorth || ''}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <SelectSourceOfFunds
              required={true}
              error={!!validation.sourceOfFunds}
              msg={validation.sourceOfFunds}
              name="sourceOfFunds"
              label="What are you using to fund this account?"
              value={
                data.sourceOfFunds
                  ? data.sourceOfFunds?.split(',')?.map((v) => {
                      return {
                        value: v,
                        label: v,
                      };
                    })
                  : []
              }
              onChange={handleMultipleFundsChange}
            />
          </div>

          {data?.sourceOfFunds?.includes('Others') && (
            <div className="grd-cell">
              <TextField
                required={true}
                error={!!validation.sourceOfFundsDescription}
                msg={validation.sourceOfFundsDescription}
                max={50}
                name="sourceOfFundsDescription"
                label="Other"
                placeholder="Other"
                type="text"
                value={data.sourceOfFundsDescription || ''}
                onChange={handleChange}
              />
            </div>
          )}
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <SelectSystemCode
              required={true}
              error={!!validation.riskTolerance}
              msg={validation.riskTolerance}
              name="riskTolerance"
              label="Risk Tolerance"
              placeholder="Risk Tolerance"
              type="Risk Tolerance"
              value={data.riskTolerance || ''}
              onChange={handleChange}
            />
          </div>
        </div>
      </form>
    </FormBase>
  );
}
